"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.compilePropertyDetails = exports.integrationTypeToMarketingTrackingValue = exports.productTypeToMarketingTrackingValue = exports.compileBillerInformation = void 0;
var biller_1 = require("../biller");
var eligibility_1 = require("../eligibility");
var compileBillerInformation = function (biller) {
    var name = biller.name, type = biller.type, system = biller.system;
    var integrationType = (function () {
        if (type === biller_1.IntegrationType[biller_1.IntegrationType.DIRECT_INTEGRATION]) {
            if (system !== undefined && system !== null) {
                return "".concat(type, "_").concat(system.toUpperCase());
            }
            return type;
        }
        else if (type === biller_1.IntegrationType[biller_1.IntegrationType.PORTAL] ||
            type === biller_1.IntegrationType[biller_1.IntegrationType.FLEX_ANYWHERE]) {
            return type;
        }
        return '';
    })();
    var sanitizedName = (function () {
        if (name.endsWith(' [Generic Portal]')) {
            return name.replace(' [Generic Portal]', '');
        }
        return name;
    })();
    return {
        propertyName: sanitizedName,
        integrationType: integrationType
    };
};
exports.compileBillerInformation = compileBillerInformation;
var productTypeToMarketingTrackingValue = function (productType) {
    if (productType === undefined || productType === null) {
        return 'RENT_SPLIT_LEGACY';
    }
    else if (productType === eligibility_1.SLCType.CLASSIC) {
        return 'SLC';
    }
    return eligibility_1.SLCType[productType];
};
exports.productTypeToMarketingTrackingValue = productTypeToMarketingTrackingValue;
var integrationTypeToMarketingTrackingValue = function (integrationType, billingIntegrationType) {
    switch (integrationType) {
        case biller_1.IntegrationType.YARDI:
        case biller_1.IntegrationType.REALPAGE:
            return "".concat(biller_1.IntegrationType[biller_1.IntegrationType.DIRECT_INTEGRATION], "_").concat(biller_1.IntegrationType[integrationType]);
        case biller_1.IntegrationType.DIRECT_INTEGRATION:
            if (billingIntegrationType !== undefined && billingIntegrationType !== null) {
                return "".concat(biller_1.IntegrationType[biller_1.IntegrationType.DIRECT_INTEGRATION], "_").concat(billingIntegrationType);
            }
            return biller_1.IntegrationType[biller_1.IntegrationType.DIRECT_INTEGRATION];
        case biller_1.IntegrationType.PORTAL:
        case biller_1.IntegrationType.FLEX_ANYWHERE:
            return biller_1.IntegrationType[integrationType];
        default:
            return integrationType;
    }
};
exports.integrationTypeToMarketingTrackingValue = integrationTypeToMarketingTrackingValue;
var compilePropertyDetails = function (property) {
    if ((0, biller_1.isBillerPropertyDetails)(property)) {
        var propName = property.name, pmcName = property.pmc_name, integrationType = property.integration_type, billingIntegrationType = property.billing_integration_type, currentTier = property.current_tier, qualifiedTier = property.qualified_tier;
        return __assign(__assign({ propName: propName, pmcName: pmcName, integrationType: (0, exports.integrationTypeToMarketingTrackingValue)(integrationType, billingIntegrationType) }, (currentTier !== null && { currentTier: currentTier })), (qualifiedTier !== null && { qualifiedTier: qualifiedTier }));
    }
    else {
        var display_name = property.display_name, portal_name = property.portal_name;
        if ((0, biller_1.isBillerFlexAnywhereLongTailPortal)(property)) {
            return {
                propName: display_name,
                pmcName: portal_name || biller_1.FlexAnywherePortalName.FLEX_ANYWHERE,
                integrationType: biller_1.IntegrationType.FLEX_ANYWHERE
            };
        }
        else if ((0, biller_1.isBillerOONPortal)(property)) {
            return {
                propName: display_name,
                pmcName: portal_name,
                integrationType: biller_1.IntegrationType.FLEX_ANYWHERE
            };
        }
        else if ((0, biller_1.isGenericPortal)(property)) {
            return {
                propName: display_name,
                pmcName: portal_name,
                integrationType: biller_1.IntegrationType.PORTAL
            };
        }
    }
};
exports.compilePropertyDetails = compilePropertyDetails;
